import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 35, viewBox: "0 0 40 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 2.5L35 32.5M35 2.5L5 32.5", stroke: "white", strokeWidth: 5, strokeLinecap: "round" }));
export default SvgClose;
